export default {
  props: {
    title: String,
    description: String,
    icon: Object,
    helpButton: Boolean
  }
};